import styled from 'styled-components';

import { useFilter } from '@context/FilterContext';
import { PriceRangeSlider, ColorOption } from '@components/listing';
import CustomCheckbox from '@components/ui/CustomCheckbox';
import { Caption2 } from '@components/styles/Typography';

const FilterOption = ({ name, queryID, hexCode, slug }) => {
    const {
        isFilterSelected,
        onCategoriesChange,
        onColorsChange,
        onSizesChange,
        onQueriesChange,
    } = useFilter();
    const isSelected = isFilterSelected(queryID);

    if (slug === 'color') {
        const handleColourClick = () => {
            onColorsChange([queryID]);
        };
        return (
            <ColorOption
                onColorChange={handleColourClick}
                isSelected={isSelected}
                name={name}
                color={hexCode}
            />
        );
    }

    if (slug === 'price') {
        return <PriceRangeSlider min={0} max={300} />;
    }

    if (slug === 'size-set') {
        const handleSizeClick = () => {
            onSizesChange([queryID]);
        };
        const isSizeSelected = isFilterSelected(queryID);
        return (
            <Option
                isSelected={isSizeSelected}
                onClick={handleSizeClick}
                sizeSet={slug === 'size-set'}
            >
                <CustomCheckbox selected={isSizeSelected} />
                <Caption2>{name}</Caption2>
            </Option>
        );
    }

    if (
        slug === 'categories' ||
        slug === 'fabric' ||
        slug === 'style' ||
        slug === 'model' ||
        slug === 'brand'
    ) {
        const handleCategoryClick = () => {
            onCategoriesChange([queryID]);
        };
        return (
            <Option isSelected={isSelected} onClick={handleCategoryClick}>
                <CustomCheckbox selected={isSelected} />
                <Caption2>{name}</Caption2>
            </Option>
        );
    }

    const handleQueryClick = () => {
        onQueriesChange([queryID], slug);
    };
    return (
        <Option isSelected={isSelected} onClick={handleQueryClick}>
            <CustomCheckbox selected={isSelected} />
            <Caption2>{name}</Caption2>
        </Option>
    );
};

const Option = styled.div`
    display: flex;
    align-items: center;
    text-transform: uppercase;
    width: ${({ sizeSet }) => (sizeSet ? '180px' : 'max-content')};
    min-width: calc(100% / 3);
    max-width: ${({ sizeSet }) => (sizeSet ? 'unset' : 'calc(100% / 3)')};
    padding: 20px 0;

    span {
        color: ${({ isSelected, theme }) =>
            isSelected
                ? `${theme.colors.primary}`
                : `${theme.colors.bgGray25}`};
        cursor: pointer;
        margin-left: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (max-width: 1024px) {
        min-width: calc(100% / 2);
    }
`;

export default FilterOption;
